// src/index.tsx

/**
 * React application bootstrap for the Quantik Mind enterprise frontend.
 *
 * This module initializes the root React renderer, applies the global
 * Material UI theme configuration, mounts the CSS baseline, and renders
 * the main enterprise application into the browser DOM.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import './index.css';
import App from './App';
import enterpriseTheme from './theme/enterpriseTheme';

/**
 * Resolve the root DOM container used by the React application.
 */
const rootElement = document.getElementById('root') as HTMLElement;

/**
 * Create the React root and render the enterprise application.
 *
 * The application is wrapped with:
 * - React.StrictMode for development-time safety checks
 * - ThemeProvider for global Material UI theming
 * - CssBaseline for consistent cross-browser base styling
 */
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={enterpriseTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);